import { render, staticRenderFns } from "./WebpackAnalyzer.vue?vue&type=template&id=67bf5fe8&scoped=true"
import script from "./WebpackAnalyzer.vue?vue&type=script&lang=js"
export * from "./WebpackAnalyzer.vue?vue&type=script&lang=js"
import style0 from "./WebpackAnalyzer.vue?vue&type=style&index=0&id=67bf5fe8&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bf5fe8",
  null
  
)

export default component.exports